<template>
    <div id="otTooltip" :style="tooltip">
        <span id="otContent">
            <slot></slot>
        </span>
        <span id="closeButtonWrapper">
            <button id="otCloseButton" type="button" @click="$emit('dismiss')">
                <img src="../../assets/img/icons/round-close-24px.svg" width="16" />
            </button>
        </span>
        <img
            id="otTooltipArrow"
            :style="tooltipArrow"
            src="../../assets/img/onboarding-tooltip/tooltip-arrow-border.svg"
        />
    </div>
</template>

<script>
export default {
    data() {
        return {
            tooltip: {
                top: "auto",
                left: "auto"
            },
            tooltipArrow: {
                top: 0,
                left: 0
            },
            timeout: null
        };
    },
    props: {
        elementReference: {
            type: HTMLElement,
            required: true,
            default: () => {}
        }
    },
    methods: {
        positionTooltip() {
            const rect = this.$el.getBoundingClientRect();
            let targetRect = this.elementReference.getBoundingClientRect();

            this.tooltip.left = targetRect.left + targetRect.width + 10 + "px";
            this.tooltip.top = targetRect.top + targetRect.height / 2 - rect.height / 2 + "px";

            this.tooltipArrow.top = rect.height / 2 - 11 + "px";
            this.tooltipArrow.left = "-10px";
        }
    },
    mounted() {
        this.positionTooltip();
    }
};
</script>

<style>
#otTooltip {
    position: fixed;

    width: 324px;

    display: grid;
    grid-template-columns: auto 24px;

    background-color: white;

    padding: 12px;

    border: 2px solid var(--primary-blue);
    border-radius: 4px;

    box-shadow: 0px 16px 16px rgba(35, 38, 43, 0.24);

    z-index: 999;
}

#otContent > p {
    font-family: "Nunito";
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    margin: 0;
    padding: 0;
}

#otTooltipArrow {
    position: absolute;

    width: 10px;
    height: 22px;
}

#otCloseButton {
    opacity: 0.87;
}

#otCloseButton:hover {
    opacity: 1;
}
</style>
